import React from 'react';
import { useDispatch } from 'react-redux';
import { useRothConversion } from './useRothConversion';
import { RothConversionChart } from './components/RothConversionChart/RothConversionChart';
import { RothConversionTable } from './components/RothConversionTable/RothConversionTable';
import { setSelectedTab } from '../../../../state/actions';
import { DEFAULT_TAB } from '../../../../GoalPage.constants';

export const RothConversion = () => {
  const { data } = useRothConversion();

  const dispatch = useDispatch();

  if (!data) {
    // This can happen if the user removes the Roth Conversion what-if
    dispatch(setSelectedTab({ tab: DEFAULT_TAB }));

    return null;
  }

  const chartKey = `${data.maxTaxBracket?.value}`;

  return (
    <>
      <RothConversionChart key={chartKey} data={data} />

      <RothConversionTable data={data} />
    </>
  );
};
